import { render, staticRenderFns } from "./setURL.vue?vue&type=template&id=0e29bdef&scoped=true&"
import script from "./setURL.vue?vue&type=script&lang=js&"
export * from "./setURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e29bdef",
  null
  
)

export default component.exports